/**
 * Simple Tabs component
 *
 * Switches between tabbed content.
 * This functionality is provided as a class which means you can have multiple, and independent, tab components
 * on the same page. You will need to create a new instantiate of this class for each component you want to target.
 *
 * Please note that the selectors should be unique and always reference the container selector like in the
 * example selectors below:
 *
 * new Tabs({
 *       container: '.js-simple-tabs',
 *       header: '.js-simple-tabs > .js-simple-tabs-header',
 *       body: '.js-simple-tabs > .js-simple-tabs-body'
 * });
 *
 * Example usage (HTML):
 *      <div class="js-simple-tabs">
 *          <ul class="js-simple-tabs-header">
 *              <li data-tab="news">
 *                  Latest News
 *              </li>
 *          </ul>
 *          <ul class="js-simple-tabs-body">
 *              <li data-tab="news">
 *                  <p>lorem ipsum...</p>
 *              </li>
 *          </ul>
 *      </div>
 */
export default class SimpleTabs {
  constructor(selectors) {
    const self = this;

    this._selectors = selectors;

    // Event :: open new tab
    document.querySelectorAll(this._selectors.header + ' li').forEach(item => {
      item.addEventListener('click', self.selectTab.bind(self));
    });

    // By default, open first tab
    this.openFirstTab();
  }

  selectTab(e) {
    const tabName = e.currentTarget.getAttribute('data-tab');

    this.closeAllTabs();

    this.openTab(tabName);
  }

  openFirstTab() {
    const tabName = document.querySelector(this._selectors.header + ' li').getAttribute('data-tab');
    this.openTab(tabName);
  }

  openTab(tabName) {
    document
      .querySelector(this._selectors.header + ' > li[data-tab="'+tabName+'"]')
      .classList.add('active')
    ;

    const tabbedContent = document.querySelector(this._selectors.body + ' > li[data-tab="'+tabName+'"]');
    tabbedContent.style.display = 'block';

    // Timeout added so the animation be triggered
    setTimeout(() => {
      tabbedContent.classList.add('active');
    }, 50);
  }

  closeTab(tabName) {
    document
      .querySelector(this._selectors.header + ' > li[data-tab="'+tabName+'"]')
      .classList.remove('active')
    ;

    const tabbedContent = document.querySelector(this._selectors.body + ' > li[data-tab="'+tabName+'"]');
    tabbedContent.style.display = 'none';
    tabbedContent.classList.remove('active');
  }

  closeAllTabs() {
    const self = this;

    document.querySelectorAll(this._selectors.header + ' > li').forEach(item => {
      const tabName = item.getAttribute('data-tab');
      self.closeTab(tabName);
    });
  }
}
